export const categoryHref = (id: string): string => `/categories/${id}`;
